// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Main Layout ===== */

.banana-sequencing-container {
  display: flex;
  flex-direction: column;
  padding: 10px;
  box-sizing: border-box;
}


.banana-info-icon {
  color: #3b82f6; /* Modern Blue information accent color */
  flex-shrink: 0;
}



@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.banana-sequencing-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  padding: 12px 20px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
  border: 1px solid #f1f5f9;
  flex-shrink: 0; /*  merged */
}

.header-left-controls {
  display: flex;
  align-items: center;
}

.header-right-controls {
  display: flex;
  gap: 12px;
  align-items: center;
}

/* ===== Location Display ===== */


.lock-icon {
  color: #ef4444; /* Beautiful error red lock icon */
  display: flex;
  align-items: center;
}


.location-display {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}



.location-id-text {
  text-align: center;
  font-family: 'JetBrains Mono', 'Fira Code', monospace;
  font-weight: 600;
  color: #334155;
}


/* ===== Old Sequence Badge ===== */
.old-sequence-badge {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  background-color: #eff6ff !important; /* light blue shade box */
  color: #1e40af !important; /* blue color */
  border-radius: 4px !important;
  padding: 4px 8px !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  width: auto !important;
  min-width: 40px !important;
  height: auto !important;
  margin: auto !important;
}

/* ===== Table Theme ===== */

.banana-table-theme {
  flex: 1 1; /*  merged */
  display: flex;
  flex-direction: column;
  min-height: 0;

  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.06);
  border: 1px solid #f1f5f9;
  background-color: #ffffff;
}

/* Modern Rounded Border for the Full Table */
.banana-table-theme table {
  border-collapse: separate !important;
  border-spacing: 0 !important;
  width: 100%;
}

/* Header - Modern Flat Styling with subtle typography & borders */
.banana-table-theme table thead th {
  background: linear-gradient(135deg, #4f46e5, #3b82f6) !important;
  color: #ffffff !important;
  font-family: inherit;
  font-size: 0.9rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.02em;
  padding: 12px 15px !important;
  position: sticky;
  top: 0;
  z-index: 10;
  text-align: center !important;   /* <-- Center header text */
  border-bottom: 2px solid rgba(0, 0, 0, 0.1) !important;
  border-top: none !important;
  box-shadow: 0 4px 10px rgba(79, 70, 229, 0.15) !important;
}

/* Right-align numeric/execution columns if desired, but keep simple left/center alignments */
.banana-table-theme table thead th:first-child,
.banana-table-theme table tbody td:first-child > div {
  padding-left: 0 !important;
}


/* Rows Styling with Soft Alternating Colors and Transition */
.banana-table-theme table tbody tr {
  background-color: #ffffff;
  transition: background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.banana-table-theme table tbody tr:nth-child(even) {
  background-color: #f8fafc; /* Sleek, very subtle cool gray alternative */
}

/* Row Hover State matching the design language */
.banana-table-theme table tbody tr:hover {
  background-color: #f1f5f9 !important;
}

/* Cells - Modern Padding and Minimal Boarders - with values stretching to fill */
.banana-table-theme td {
  border-bottom: 1px solid #f1f5f9 !important;
  padding: 0 !important; /* Let children stretch to fill entire block */
  font-size: 0.875rem !important;
  color: #334155;
  font-weight: 500;
  vertical-align: middle;
  white-space: nowrap !important;
}

/* Make inner values and container blocks fill the entire cell dimensions */
.banana-table-theme td > span,
.banana-table-theme td > div {
  display: flex !important;
  align-items: center;
  width: 100% !important;
  height: 100% !important;
  min-height: 36px !important; /* Ensure a consistent comfortable cell height, reduced from 48px */
  padding: 6px 12px !important; /* Reduced padding from 12px 16px */
  box-sizing: border-box !important;
  white-space: nowrap !important;
}


/* Input Cell & Edit State Highlights */
.banana-table-theme td:focus-within {
  background-color: #f5f3ff !important; /* Soft violet edit backdrop */
  box-shadow: inset 0 0 0 2px #6366f1 !important;
  border-radius: 4px;
}

.banana-table-theme input {
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  padding: 6px 12px !important; /* Reduced padding from 12px 16px */
  border-radius: 0 !important; /* Corner-to-corner block */
  border: none !important; /* Remove internal border since cell outline serves as border */
  background-color: transparent !important; /* Take on background color of parent TD focus */
  font-size: 0.875rem !important;
  color: #1e293b !important;
  font-weight: 600 !important;
  box-shadow: none !important;
  transition: all 0.2s ease !important;
}

.banana-table-theme input:focus {
  box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.4);
  border-color: #4f46e5;
}

/* Special prefix element styling inside cell */
.banana-table-theme .location-display {
  font-weight: 600 !important;
  color: #0f172a !important;
}

/* ===== Scroll Control ===== */

.banana-table-theme .table-wrapper {
  flex: 1 1;
  display: flex;            /*  ADD THIS */
  flex-direction: column;   /*  ADD THIS */
  overflow: auto !important;
  min-height: 0;
}

/* ===== Beautiful Modern Pagination Style (Only for Banana Sequencing) ===== */

/* Footer Pagination Container */
.banana-table-theme .MuiBox-root {
  flex-shrink: 0;
  background-color: #ffffff !important;
  background-image: none !important;
  border-top: 1px solid #f1f5f9 !important;
  padding: 16px 24px !important;
  border-radius: 0 0 14px 14px;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.015) !important;
}

/* Left part (Rows info) */
.banana-table-theme .MuiBox-root > div:first-child {
  font-family: inherit;
  font-size: 0.85rem !important;
  color: #64748b !important;
  font-weight: 500 !important;
  display: flex !important;
  align-items: center !important;
}

/* Rows per page selector */
.banana-table-theme .MuiBox-root .MuiSelect-root,
.banana-table-theme .MuiBox-root .MuiOutlinedInput-root {
  background-color: #f8fafc !important;
  border-radius: 8px !important;
  font-size: 0.825rem !important;
  font-weight: 600 !important;
  color: #334155 !important;
  border: 1px solid #cbd5e1 !important;
  transition: all 0.2s ease !important;
  height: 32px !important;
}

.banana-table-theme .MuiBox-root .MuiOutlinedInput-root fieldset {
  border: none !important; /* Hide standard MUI fieldset border since we style the container */
}

.banana-table-theme .MuiBox-root .MuiOutlinedInput-root:hover {
  border-color: #6366f1 !important;
  background-color: #ffffff !important;
}

/* Pagination Control buttons (Numbers, Prev, Next) */
.banana-table-theme .MuiBox-root div[style*="border: 1px solid"] {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  border-radius: 8px !important;
  border: none !important; /* Flat design - remove borders */
  background-color: #f1f5f9 !important; /* Modern neutral pill */
  color: #475569 !important;
  font-weight: 600 !important;
  font-size: 0.85rem !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  cursor: pointer !important;
  -webkit-user-select: none !important;
          user-select: none !important;
}

/* Inactive button hover */
.banana-table-theme .MuiBox-root div[style*="border: 1px solid"]:not([style*="background-color: #007bff"]):not([style*="not-allowed"]):hover {
  background-color: #e2e8f0 !important;
  color: #0f172a !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05) !important;
}

/* Active Page Button Style */
.banana-table-theme .MuiBox-root div[style*="background-color: #007bff"] {
  background: linear-gradient(135deg, #4f46e5, #3b82f6) !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  border: none !important;
  box-shadow: 0 4px 10px rgba(79, 70, 229, 0.3) !important;
  transform: translateY(-1px) !important;
}

/* Click feedback */
.banana-table-theme .MuiBox-root div[style*="border: 1px solid"]:active {
  transform: translateY(0px) !important;
}

/* Disabled state (Prev / Next at boundaries) */
.banana-table-theme .MuiBox-root div[style*="not-allowed"] {
  background-color: #f8fafc !important;
  color: #cbd5e1 !important;
  cursor: not-allowed !important;
  opacity: 0.6 !important;
  transform: none !important;
  box-shadow: none !important;
}

/* Divider dots (...) style */
.banana-table-theme .MuiBox-root div[style*="color: #999"] {
  color: #94a3b8 !important;
  font-weight: 500 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Jump control labels */
.banana-table-theme .MuiBox-root span[style*="Jump to:"] {
  color: #64748b !important;
  font-weight: 500 !important;
}

/* Jump input inside TextField */
.banana-table-theme .MuiBox-root .MuiTextField-root {
  width: 70px !important;
  height: 32px !important;
}

.banana-table-theme .MuiBox-root .MuiInputBase-root {
  background-color: #f8fafc !important;
  border-radius: 8px !important;
  height: 32px !important;
  font-size: 0.825rem !important;
  font-weight: 600 !important;
  color: #334155 !important;
  border: 1px solid #cbd5e1 !important;
  transition: all 0.2s ease !important;
}

.banana-table-theme .MuiBox-root .MuiInputBase-input {
  padding: 0 8px !important;
  text-align: center !important;
}

.banana-table-theme .MuiBox-root .MuiInputBase-root fieldset {
  border: none !important;
}

.banana-table-theme .MuiBox-root .MuiInputBase-root:hover {
  border-color: #6366f1 !important;
  background-color: #ffffff !important;
}

.banana-table-theme .MuiBox-root .MuiInputBase-root.Mui-focused {
  border-color: #4f46e5 !important;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15) !important;
}

/* Reset link */
.banana-table-theme span[role="button"] {
  font-weight: 500;
  color: #6366f1;
}

.banana-table-theme span[role="button"]:hover {
  text-decoration: underline;
  color: #1d4ed8;
}

/* ===== Fill Empty Table Space ===== */


/* Make rows stretch */
.banana-table-theme table tbody tr {
  height: auto;
}

/* Optional: evenly stretch rows when few rows */
.banana-table-theme table tbody:has(tr:only-child) tr {
  height: 100%;
}


.banana-reset-btn {
  width: auto !important;  
}



.banana-table-theme {
  position: relative;
}

/*  Button stays normal size */
.banana-reset-wrapper {
  position: absolute;
  right: 700px;
  bottom: 80px;
  z-index: 5;
}


/* ===== Fancy Controls ===== */

.fancy-toggle-wrapper {
  background: #f8fafc;
  padding: 4px 16px;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  transition: all 0.2s ease-in-out;
}

.fancy-toggle-wrapper:hover {
  border-color: #6366f1;
  background-color: #f5f3ff;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.08);
}

.fancy-toggle-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #64748b;
  transition: color 0.2s ease-in-out;
  -webkit-user-select: none;
          user-select: none;
}

.fancy-toggle-label.active {
  color: #4f46e5;
}

/* Fancy Switch custom MUI styles override via class if needed, or stick to nice MUI defaults */
.fancy-switch .MuiSwitch-switchBase.Mui-checked {
  color: #4f46e5 !important;
}
.fancy-switch .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
  background-color: #6366f1 !important;
}

/* Buttons */
.btn-icon {
  margin-right: 6px;
  flex-shrink: 0;
  transition: transform 0.3s ease;
}

.fancy-refresh-btn {
  background-color: #ffffff !important;
  color: #475569 !important;
  border: 1px solid #cbd5e1 !important;
  padding: 8px 16px !important;
  border-radius: 24px !important;
  font-weight: 600 !important;
  font-size: 0.85rem !important;
  height: 38px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.03) !important;
  transition: all 0.2s ease !important;
}

.fancy-refresh-btn:hover {
  color: #0f172a !important;
  background-color: #f8fafc !important;
  border-color: #94a3b8 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
}

.fancy-refresh-btn:hover .btn-icon {
  transform: rotate(180deg);
}

.fancy-update-btn {
  background: linear-gradient(135deg, #4f46e5, #3b82f6) !important;
  color: #ffffff !important;
  border: none !important;
  padding: 8px 20px !important;
  border-radius: 24px !important;
  font-weight: 700 !important;
  font-size: 0.85rem !important;
  height: 38px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 4px 14px rgba(79, 70, 229, 0.25) !important;
  transition: all 0.2s ease !important;
}

.fancy-update-btn:not(.disabled):hover {
  background: linear-gradient(135deg, #4338ca, #2563eb) !important;
  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.35) !important;
}

.fancy-update-btn.disabled {
  background: #e2e8f0 !important;
  color: #94a3b8 !important;
  box-shadow: none !important;
  cursor: not-allowed;
  opacity: 0.8;
}

.button-container {
  width: 150px;
}

/* ===== Loading State ===== */
.banana-loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px 40px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
  border: 1px solid #f1f5f9;
  margin-top: 16px;
}

.banana-loading-text {
  margin-top: 16px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #4f46e5;
  letter-spacing: 0.05em;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.btn-icon.spin {
  animation: spin 1s linear infinite;
}

/* ===== No Data Allocated State ===== */
.banana-no-data-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 40px;
  background: radial-gradient(circle at top left, #ffffff, #f8fafc);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(0, 0, 0, 0.01);
  border: 1px solid #e2e8f0;
  max-width: 600px;
  width: 100%;
  margin: 40px auto;
  text-align: center;
}

.no-data-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: #f0fdf4; /* Light green modern background */
  border-radius: 50px;
  margin-bottom: 24px;
  box-shadow: inset 0 2px 4px rgba(74, 222, 128, 0.1);
  border: 1px solid #bbf7d0;
}

.no-data-icon {
  color: #16a34a; /* vibrant modern green representing freshness/allocated status */
}

.no-data-title {
  font-size: 1.5rem;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 12px 0;
  letter-spacing: -0.02em;
}

.no-data-description {
  font-size: 0.95rem;
  color: #64748b;
  line-height: 1.6;
  max-width: 440px;
  margin: 0 0 32px 0;
}

.fancy-no-data-refresh-btn {
  background: linear-gradient(135deg, #10b981, #059669) !important; /* Beautiful green theme matching banana state */
  color: #ffffff !important;
  border: none !important;
  padding: 10px 24px !important;
  border-radius: 24px !important;
  font-weight: 700 !important;
  font-size: 0.85rem !important;
  height: 42px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.25) !important;
  transition: all 0.2s ease !important;
}

.fancy-no-data-refresh-btn:hover {
  background: linear-gradient(135deg, #059669, #047857) !important;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.35) !important;
  transform: translateY(-1px);
}

/* ===== Sequence Cell Styles ===== */

.sequence-cell {
  display: flex;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0 !important;
}

.sequence-input {
  width: 100% !important;
  height: 100% !important;
  flex: 1 1;                     /*  key for flex fill */
  padding: 0 24px 0 12px;     /*  leave space for arrows on right */
  box-sizing: border-box;
  border: none;
  background: transparent;
  text-align: center;         /* keep your earlier alignment */
}


.sequence-input:focus {
  box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.4);
  border-color: #4f46e5;
}

.new-seq-cell-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.new-seq-cell-wrapper .sequence-input {
  width: 100%;
  padding-right: 28px; /* Make space for the icon */
}

.clear-icon {
  position: absolute;
  right: 8px;
  color: #9ca3af;
  cursor: pointer;
  transition: color 0.2s ease;
}

.clear-icon:hover {
  color: #ef4444;
}

/* Remove padding applied by table rule */
.banana-table-theme td > .new-seq-cell {
  padding: 0 !important;
}

/* Ensure full stretch */
.new-seq-cell {
  display: flex;
  width: 100%;
  height: 100%;
}

/* ===== Editable Table Overrides ===== */

.banana-table-theme {
  position: relative;
}



.banana-table-shrink {
  transform: scale(0.88) translateY(8px);
  transform-origin: center top;
  width: 90%;
}


/* ===== On Hand Cell Styles ===== */
.on-hand-cell {
  display: flex;
  align-items: baseline;
  justify-content: center !important;
  gap: 4px;
  background-color: #f3f4f6;
  padding: 4px 8px;
  border-radius: 16px;
  width: 100%;
  margin: 0 auto;
  border: 1px solid #e5e7eb;
}

.on-hand-quantity {
  font-weight: 600;
  font-size: 0.9rem;
  color: #1f2937;
}

.on-hand-unit {
  font-size: 0.9rem;
  color: #6b7280;
  font-weight: 500;
}

.location-display {
  display: flex;
  align-items: center;
  justify-content: center !important;
  width: 100%;
  text-align: center;
}

.status-cell {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px;
  width: 100%;
  text-align: center;
}

.status-cell .lock-icon {
  color: #ef4444;
}

.sequence-update-note {
  display: flex;
  align-items: center;
  gap: 10px;

  margin-bottom: 12px;
  padding: 10px 14px;

  background: linear-gradient(135deg, #eff6ff, #dbeafe);
  border: 1px solid #93c5fd;
  border-left: 4px solid #2563eb;
  border-radius: 8px;

  color: #1e3a8a;
  font-size: 0.85rem;
  font-weight: 500;

  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.08);
}

.sequence-note-asterisk {
  color: #2563eb;
  font-weight: 800;
  font-size: 1rem;
  flex-shrink: 0;
}

.sequence-update-note svg {
  color: #2563eb;
  flex-shrink: 0;
}




.nested-item-row {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  min-height: 36px;

  padding: 8px 12px !important;

  border-bottom: 1px solid #e5e7eb;
  box-sizing: border-box;
}

.nested-item-row:last-child {
  border-bottom: none;
}

.nested-onhand-row {
  gap: 4px;
  background: #f8fafc;
}

/* Optional tree-style bullet */

.nested-item-row::before {
  content: "•";
  color: #4f46e5;
  font-weight: bold;
  margin-right: 8px;
}

/* ==========================================
   Combined Item + Inventory Column
========================================== */


.nested-item-row {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;

  width: 100%;
  min-height: 36px;

  padding: 8px 12px !important;

  border-bottom: 1px solid #e5e7eb;
}


.inventory-item-id {
  font-weight: 600;
  color: #1f2937;
  font-family: 'JetBrains Mono', monospace;
}

.inventory-divider {
  flex: 1 1;
  margin: 0 12px;
  border-bottom: 1px dashed #cbd5e1;
}

.inventory-onhand {
  font-weight: 600;
  color: #4f46e5;
  white-space: nowrap;
}

.empty-item {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100%;
}

/* ==========================================
   Inventory Cards
========================================== */

.nested-item-container {
  display: flex !important;
  flex-direction: column !important;
  gap: 6px;
  width: 100%;
  padding: 4px !important;
}

.inventory-card {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  gap: 8px;

  min-height: 36px;
  padding: 8px 12px !important;

  border-radius: 10px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.inventory-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0,0,0,0.08);
}

.inventory-item-id {
  font-family: 'JetBrains Mono', monospace;
  font-weight: 700;
  margin-right: 4px;
}

.inventory-onhand {
  font-size: 0.85rem;
  font-weight: 700;
}

`, "",{"version":3,"sources":["webpack://./src/components/selfService/BananaSequencing.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;;AAGA;EACE,cAAc,EAAE,yCAAyC;EACzD,cAAc;AAChB;;;;AAIA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,cAAc,EAAE,YAAY;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,iCAAiC;;;AAGjC;EACE,cAAc,EAAE,kCAAkC;EAClD,aAAa;EACb,mBAAmB;AACrB;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;;;AAIA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,gBAAgB;EAChB,cAAc;AAChB;;;AAGA,mCAAmC;AACnC;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,oCAAoC,EAAE,yBAAyB;EAC/D,yBAAyB,EAAE,eAAe;EAC1C,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,4BAA4B;;AAE5B;EACE,SAAO,EAAE,YAAY;EACrB,aAAa;EACb,sBAAsB;EACtB,aAAa;;EAEb,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,WAAW;AACb;;AAEA,kEAAkE;AAClE;EACE,gEAAgE;EAChE,yBAAyB;EACzB,oBAAoB;EACpB,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,6BAA6B,IAAI,2BAA2B;EAC5D,sDAAsD;EACtD,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA,6FAA6F;AAC7F;;EAEE,0BAA0B;AAC5B;;;AAGA,6DAA6D;AAC7D;EACE,yBAAyB;EACzB,8DAA8D;AAChE;;AAEA;EACE,yBAAyB,EAAE,6CAA6C;AAC1E;;AAEA,iDAAiD;AACjD;EACE,oCAAoC;AACtC;;AAEA,iFAAiF;AACjF;EACE,2CAA2C;EAC3C,qBAAqB,EAAE,8CAA8C;EACrE,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,2EAA2E;AAC3E;;EAEE,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B,EAAE,mEAAmE;EAChG,4BAA4B,EAAE,mCAAmC;EACjE,iCAAiC;EACjC,8BAA8B;AAChC;;;AAGA,uCAAuC;AACvC;EACE,oCAAoC,EAAE,8BAA8B;EACpE,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B,EAAE,mCAAmC;EACjE,2BAA2B,EAAE,2BAA2B;EACxD,uBAAuB,EAAE,+DAA+D;EACxF,wCAAwC,EAAE,gDAAgD;EAC1F,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA,+CAA+C;AAC/C;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,+BAA+B;;AAE/B;EACE,SAAO;EACP,aAAa,aAAa,cAAc;EACxC,sBAAsB,IAAI,cAAc;EACxC,yBAAyB;EACzB,aAAa;AACf;;AAEA,+EAA+E;;AAE/E,gCAAgC;AAChC;EACE,cAAc;EACd,oCAAoC;EACpC,iCAAiC;EACjC,wCAAwC;EACxC,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;EACxB,yCAAyC;EACzC,8BAA8B;EAC9B,uDAAuD;AACzD;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;;EAEE,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,oCAAoC;EACpC,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB,EAAE,mEAAmE;AAC9F;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA,qDAAqD;AACrD;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB,EAAE,iCAAiC;EAC1D,oCAAoC,EAAE,wBAAwB;EAC9D,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,4DAA4D;EAC5D,0BAA0B;EAC1B,oCAA4B;UAA5B,4BAA4B;AAC9B;;AAEA,0BAA0B;AAC1B;EACE,oCAAoC;EACpC,yBAAyB;EACzB,sCAAsC;EACtC,oDAAoD;AACtD;;AAEA,6BAA6B;AAC7B;EACE,gEAAgE;EAChE,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,wDAAwD;EACxD,sCAAsC;AACxC;;AAEA,mBAAmB;AACnB;EACE,qCAAqC;AACvC;;AAEA,+CAA+C;AAC/C;EACE,oCAAoC;EACpC,yBAAyB;EACzB,8BAA8B;EAC9B,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,uCAAuC;;;AAGvC,sBAAsB;AACtB;EACE,YAAY;AACd;;AAEA,gDAAgD;AAChD;EACE,YAAY;AACd;;;AAGA;EACE,sBAAsB;AACxB;;;;AAIA;EACE,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;;AAGA,+BAA+B;;AAE/B;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,+FAA+F;AAC/F;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;EACpC,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,oDAAoD;EACpD,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;EAChC,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gEAAgE;EAChE,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,yDAAyD;EACzD,oCAAoC;AACtC;;AAEA;EACE,gEAAgE;EAChE,yDAAyD;AAC3D;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iEAAiE;EACjE,mBAAmB;EACnB,6EAA6E;EAC7E,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAE,kCAAkC;EACvD,mBAAmB;EACnB,mBAAmB;EACnB,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,cAAc,EAAE,iEAAiE;AACnF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gEAAgE,EAAE,gDAAgD;EAClH,yBAAyB;EACzB,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,0DAA0D;EAC1D,oCAAoC;AACtC;;AAEA;EACE,gEAAgE;EAChE,0DAA0D;EAC1D,2BAA2B;AAC7B;;AAEA,qCAAqC;;AAErC;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,SAAO,sBAAsB,uBAAuB;EACpD,sBAAsB,MAAM,qCAAqC;EACjE,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB,UAAU,gCAAgC;AAC9D;;;AAGA;EACE,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB,EAAE,4BAA4B;AACnD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA,yCAAyC;;AAEzC;EACE,kBAAkB;AACpB;;;;AAIA;EACE,sCAAsC;EACtC,4BAA4B;EAC5B,UAAU;AACZ;;;AAGA,oCAAoC;AACpC;EACE,aAAa;EACb,qBAAqB;EACrB,kCAAkC;EAClC,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,QAAQ;EACR,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET,mBAAmB;EACnB,kBAAkB;;EAElB,qDAAqD;EACrD,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;;EAElB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;;EAEhB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;;;;AAKA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;;EAElC,gBAAgB;;EAEhB,4BAA4B;;EAE5B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,mBAAmB;AACrB;;AAEA,+BAA+B;;AAE/B;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;4CAE4C;;;AAG5C;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;;EAEzC,WAAW;EACX,gBAAgB;;EAEhB,4BAA4B;;EAE5B,gCAAgC;AAClC;;;AAGA;EACE,gBAAgB;EAChB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,WAAW;AACb;;AAEA;;4CAE4C;;AAE5C;EACE,wBAAwB;EACxB,iCAAiC;EACjC,QAAQ;EACR,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,8BAA8B;EAC9B,QAAQ;;EAER,gBAAgB;EAChB,4BAA4B;;EAE5B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["/* ===== Main Layout ===== */\n\n.banana-sequencing-container {\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  box-sizing: border-box;\n}\n\n\n.banana-info-icon {\n  color: #3b82f6; /* Modern Blue information accent color */\n  flex-shrink: 0;\n}\n\n\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.banana-sequencing-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n  padding: 12px 20px;\n  background-color: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);\n  border: 1px solid #f1f5f9;\n  flex-shrink: 0; /*  merged */\n}\n\n.header-left-controls {\n  display: flex;\n  align-items: center;\n}\n\n.header-right-controls {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n/* ===== Location Display ===== */\n\n\n.lock-icon {\n  color: #ef4444; /* Beautiful error red lock icon */\n  display: flex;\n  align-items: center;\n}\n\n\n.location-display {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n\n\n.location-id-text {\n  text-align: center;\n  font-family: 'JetBrains Mono', 'Fira Code', monospace;\n  font-weight: 600;\n  color: #334155;\n}\n\n\n/* ===== Old Sequence Badge ===== */\n.old-sequence-badge {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  background-color: #eff6ff !important; /* light blue shade box */\n  color: #1e40af !important; /* blue color */\n  border-radius: 4px !important;\n  padding: 4px 8px !important;\n  font-weight: 700 !important;\n  font-size: 0.875rem !important;\n  width: auto !important;\n  min-width: 40px !important;\n  height: auto !important;\n  margin: auto !important;\n}\n\n/* ===== Table Theme ===== */\n\n.banana-table-theme {\n  flex: 1; /*  merged */\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.06);\n  border: 1px solid #f1f5f9;\n  background-color: #ffffff;\n}\n\n/* Modern Rounded Border for the Full Table */\n.banana-table-theme table {\n  border-collapse: separate !important;\n  border-spacing: 0 !important;\n  width: 100%;\n}\n\n/* Header - Modern Flat Styling with subtle typography & borders */\n.banana-table-theme table thead th {\n  background: linear-gradient(135deg, #4f46e5, #3b82f6) !important;\n  color: #ffffff !important;\n  font-family: inherit;\n  font-size: 0.9rem !important;\n  font-weight: 600 !important;\n  letter-spacing: 0.02em;\n  padding: 12px 15px !important;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  text-align: center !important;   /* <-- Center header text */\n  border-bottom: 2px solid rgba(0, 0, 0, 0.1) !important;\n  border-top: none !important;\n  box-shadow: 0 4px 10px rgba(79, 70, 229, 0.15) !important;\n}\n\n/* Right-align numeric/execution columns if desired, but keep simple left/center alignments */\n.banana-table-theme table thead th:first-child,\n.banana-table-theme table tbody td:first-child > div {\n  padding-left: 0 !important;\n}\n\n\n/* Rows Styling with Soft Alternating Colors and Transition */\n.banana-table-theme table tbody tr {\n  background-color: #ffffff;\n  transition: background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.banana-table-theme table tbody tr:nth-child(even) {\n  background-color: #f8fafc; /* Sleek, very subtle cool gray alternative */\n}\n\n/* Row Hover State matching the design language */\n.banana-table-theme table tbody tr:hover {\n  background-color: #f1f5f9 !important;\n}\n\n/* Cells - Modern Padding and Minimal Boarders - with values stretching to fill */\n.banana-table-theme td {\n  border-bottom: 1px solid #f1f5f9 !important;\n  padding: 0 !important; /* Let children stretch to fill entire block */\n  font-size: 0.875rem !important;\n  color: #334155;\n  font-weight: 500;\n  vertical-align: middle;\n  white-space: nowrap !important;\n}\n\n/* Make inner values and container blocks fill the entire cell dimensions */\n.banana-table-theme td > span,\n.banana-table-theme td > div {\n  display: flex !important;\n  align-items: center;\n  width: 100% !important;\n  height: 100% !important;\n  min-height: 36px !important; /* Ensure a consistent comfortable cell height, reduced from 48px */\n  padding: 6px 12px !important; /* Reduced padding from 12px 16px */\n  box-sizing: border-box !important;\n  white-space: nowrap !important;\n}\n\n\n/* Input Cell & Edit State Highlights */\n.banana-table-theme td:focus-within {\n  background-color: #f5f3ff !important; /* Soft violet edit backdrop */\n  box-shadow: inset 0 0 0 2px #6366f1 !important;\n  border-radius: 4px;\n}\n\n.banana-table-theme input {\n  width: 100% !important;\n  height: 100% !important;\n  margin: 0 !important;\n  padding: 6px 12px !important; /* Reduced padding from 12px 16px */\n  border-radius: 0 !important; /* Corner-to-corner block */\n  border: none !important; /* Remove internal border since cell outline serves as border */\n  background-color: transparent !important; /* Take on background color of parent TD focus */\n  font-size: 0.875rem !important;\n  color: #1e293b !important;\n  font-weight: 600 !important;\n  box-shadow: none !important;\n  transition: all 0.2s ease !important;\n}\n\n.banana-table-theme input:focus {\n  box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.4);\n  border-color: #4f46e5;\n}\n\n/* Special prefix element styling inside cell */\n.banana-table-theme .location-display {\n  font-weight: 600 !important;\n  color: #0f172a !important;\n}\n\n/* ===== Scroll Control ===== */\n\n.banana-table-theme .table-wrapper {\n  flex: 1;\n  display: flex;            /*  ADD THIS */\n  flex-direction: column;   /*  ADD THIS */\n  overflow: auto !important;\n  min-height: 0;\n}\n\n/* ===== Beautiful Modern Pagination Style (Only for Banana Sequencing) ===== */\n\n/* Footer Pagination Container */\n.banana-table-theme .MuiBox-root {\n  flex-shrink: 0;\n  background-color: #ffffff !important;\n  background-image: none !important;\n  border-top: 1px solid #f1f5f9 !important;\n  padding: 16px 24px !important;\n  border-radius: 0 0 14px 14px;\n  display: flex !important;\n  justify-content: space-between !important;\n  align-items: center !important;\n  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.015) !important;\n}\n\n/* Left part (Rows info) */\n.banana-table-theme .MuiBox-root > div:first-child {\n  font-family: inherit;\n  font-size: 0.85rem !important;\n  color: #64748b !important;\n  font-weight: 500 !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n/* Rows per page selector */\n.banana-table-theme .MuiBox-root .MuiSelect-root,\n.banana-table-theme .MuiBox-root .MuiOutlinedInput-root {\n  background-color: #f8fafc !important;\n  border-radius: 8px !important;\n  font-size: 0.825rem !important;\n  font-weight: 600 !important;\n  color: #334155 !important;\n  border: 1px solid #cbd5e1 !important;\n  transition: all 0.2s ease !important;\n  height: 32px !important;\n}\n\n.banana-table-theme .MuiBox-root .MuiOutlinedInput-root fieldset {\n  border: none !important; /* Hide standard MUI fieldset border since we style the container */\n}\n\n.banana-table-theme .MuiBox-root .MuiOutlinedInput-root:hover {\n  border-color: #6366f1 !important;\n  background-color: #ffffff !important;\n}\n\n/* Pagination Control buttons (Numbers, Prev, Next) */\n.banana-table-theme .MuiBox-root div[style*=\"border: 1px solid\"] {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  padding: 0 !important;\n  width: 32px !important;\n  height: 32px !important;\n  min-width: 32px !important;\n  border-radius: 8px !important;\n  border: none !important; /* Flat design - remove borders */\n  background-color: #f1f5f9 !important; /* Modern neutral pill */\n  color: #475569 !important;\n  font-weight: 600 !important;\n  font-size: 0.85rem !important;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  cursor: pointer !important;\n  user-select: none !important;\n}\n\n/* Inactive button hover */\n.banana-table-theme .MuiBox-root div[style*=\"border: 1px solid\"]:not([style*=\"background-color: #007bff\"]):not([style*=\"not-allowed\"]):hover {\n  background-color: #e2e8f0 !important;\n  color: #0f172a !important;\n  transform: translateY(-1px) !important;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05) !important;\n}\n\n/* Active Page Button Style */\n.banana-table-theme .MuiBox-root div[style*=\"background-color: #007bff\"] {\n  background: linear-gradient(135deg, #4f46e5, #3b82f6) !important;\n  color: #ffffff !important;\n  font-weight: 700 !important;\n  border: none !important;\n  box-shadow: 0 4px 10px rgba(79, 70, 229, 0.3) !important;\n  transform: translateY(-1px) !important;\n}\n\n/* Click feedback */\n.banana-table-theme .MuiBox-root div[style*=\"border: 1px solid\"]:active {\n  transform: translateY(0px) !important;\n}\n\n/* Disabled state (Prev / Next at boundaries) */\n.banana-table-theme .MuiBox-root div[style*=\"not-allowed\"] {\n  background-color: #f8fafc !important;\n  color: #cbd5e1 !important;\n  cursor: not-allowed !important;\n  opacity: 0.6 !important;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* Divider dots (...) style */\n.banana-table-theme .MuiBox-root div[style*=\"color: #999\"] {\n  color: #94a3b8 !important;\n  font-weight: 500 !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n/* Jump control labels */\n.banana-table-theme .MuiBox-root span[style*=\"Jump to:\"] {\n  color: #64748b !important;\n  font-weight: 500 !important;\n}\n\n/* Jump input inside TextField */\n.banana-table-theme .MuiBox-root .MuiTextField-root {\n  width: 70px !important;\n  height: 32px !important;\n}\n\n.banana-table-theme .MuiBox-root .MuiInputBase-root {\n  background-color: #f8fafc !important;\n  border-radius: 8px !important;\n  height: 32px !important;\n  font-size: 0.825rem !important;\n  font-weight: 600 !important;\n  color: #334155 !important;\n  border: 1px solid #cbd5e1 !important;\n  transition: all 0.2s ease !important;\n}\n\n.banana-table-theme .MuiBox-root .MuiInputBase-input {\n  padding: 0 8px !important;\n  text-align: center !important;\n}\n\n.banana-table-theme .MuiBox-root .MuiInputBase-root fieldset {\n  border: none !important;\n}\n\n.banana-table-theme .MuiBox-root .MuiInputBase-root:hover {\n  border-color: #6366f1 !important;\n  background-color: #ffffff !important;\n}\n\n.banana-table-theme .MuiBox-root .MuiInputBase-root.Mui-focused {\n  border-color: #4f46e5 !important;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15) !important;\n}\n\n/* Reset link */\n.banana-table-theme span[role=\"button\"] {\n  font-weight: 500;\n  color: #6366f1;\n}\n\n.banana-table-theme span[role=\"button\"]:hover {\n  text-decoration: underline;\n  color: #1d4ed8;\n}\n\n/* ===== Fill Empty Table Space ===== */\n\n\n/* Make rows stretch */\n.banana-table-theme table tbody tr {\n  height: auto;\n}\n\n/* Optional: evenly stretch rows when few rows */\n.banana-table-theme table tbody:has(tr:only-child) tr {\n  height: 100%;\n}\n\n\n.banana-reset-btn {\n  width: auto !important;  \n}\n\n\n\n.banana-table-theme {\n  position: relative;\n}\n\n/*  Button stays normal size */\n.banana-reset-wrapper {\n  position: absolute;\n  right: 700px;\n  bottom: 80px;\n  z-index: 5;\n}\n\n\n/* ===== Fancy Controls ===== */\n\n.fancy-toggle-wrapper {\n  background: #f8fafc;\n  padding: 4px 16px;\n  border-radius: 20px;\n  border: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  transition: all 0.2s ease-in-out;\n}\n\n.fancy-toggle-wrapper:hover {\n  border-color: #6366f1;\n  background-color: #f5f3ff;\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.08);\n}\n\n.fancy-toggle-label {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #64748b;\n  transition: color 0.2s ease-in-out;\n  user-select: none;\n}\n\n.fancy-toggle-label.active {\n  color: #4f46e5;\n}\n\n/* Fancy Switch custom MUI styles override via class if needed, or stick to nice MUI defaults */\n.fancy-switch .MuiSwitch-switchBase.Mui-checked {\n  color: #4f46e5 !important;\n}\n.fancy-switch .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {\n  background-color: #6366f1 !important;\n}\n\n/* Buttons */\n.btn-icon {\n  margin-right: 6px;\n  flex-shrink: 0;\n  transition: transform 0.3s ease;\n}\n\n.fancy-refresh-btn {\n  background-color: #ffffff !important;\n  color: #475569 !important;\n  border: 1px solid #cbd5e1 !important;\n  padding: 8px 16px !important;\n  border-radius: 24px !important;\n  font-weight: 600 !important;\n  font-size: 0.85rem !important;\n  height: 38px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.03) !important;\n  transition: all 0.2s ease !important;\n}\n\n.fancy-refresh-btn:hover {\n  color: #0f172a !important;\n  background-color: #f8fafc !important;\n  border-color: #94a3b8 !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;\n}\n\n.fancy-refresh-btn:hover .btn-icon {\n  transform: rotate(180deg);\n}\n\n.fancy-update-btn {\n  background: linear-gradient(135deg, #4f46e5, #3b82f6) !important;\n  color: #ffffff !important;\n  border: none !important;\n  padding: 8px 20px !important;\n  border-radius: 24px !important;\n  font-weight: 700 !important;\n  font-size: 0.85rem !important;\n  height: 38px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  box-shadow: 0 4px 14px rgba(79, 70, 229, 0.25) !important;\n  transition: all 0.2s ease !important;\n}\n\n.fancy-update-btn:not(.disabled):hover {\n  background: linear-gradient(135deg, #4338ca, #2563eb) !important;\n  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.35) !important;\n}\n\n.fancy-update-btn.disabled {\n  background: #e2e8f0 !important;\n  color: #94a3b8 !important;\n  box-shadow: none !important;\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n\n.button-container {\n  width: 150px;\n}\n\n/* ===== Loading State ===== */\n.banana-loading-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 60px 40px;\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);\n  border: 1px solid #f1f5f9;\n  margin-top: 16px;\n}\n\n.banana-loading-text {\n  margin-top: 16px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #4f46e5;\n  letter-spacing: 0.05em;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.btn-icon.spin {\n  animation: spin 1s linear infinite;\n}\n\n/* ===== No Data Allocated State ===== */\n.banana-no-data-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 80px 40px;\n  background: radial-gradient(circle at top left, #ffffff, #f8fafc);\n  border-radius: 20px;\n  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(0, 0, 0, 0.01);\n  border: 1px solid #e2e8f0;\n  max-width: 600px;\n  width: 100%;\n  margin: 40px auto;\n  text-align: center;\n}\n\n.no-data-icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  height: 80px;\n  background: #f0fdf4; /* Light green modern background */\n  border-radius: 50px;\n  margin-bottom: 24px;\n  box-shadow: inset 0 2px 4px rgba(74, 222, 128, 0.1);\n  border: 1px solid #bbf7d0;\n}\n\n.no-data-icon {\n  color: #16a34a; /* vibrant modern green representing freshness/allocated status */\n}\n\n.no-data-title {\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 0 0 12px 0;\n  letter-spacing: -0.02em;\n}\n\n.no-data-description {\n  font-size: 0.95rem;\n  color: #64748b;\n  line-height: 1.6;\n  max-width: 440px;\n  margin: 0 0 32px 0;\n}\n\n.fancy-no-data-refresh-btn {\n  background: linear-gradient(135deg, #10b981, #059669) !important; /* Beautiful green theme matching banana state */\n  color: #ffffff !important;\n  border: none !important;\n  padding: 10px 24px !important;\n  border-radius: 24px !important;\n  font-weight: 700 !important;\n  font-size: 0.85rem !important;\n  height: 42px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.25) !important;\n  transition: all 0.2s ease !important;\n}\n\n.fancy-no-data-refresh-btn:hover {\n  background: linear-gradient(135deg, #059669, #047857) !important;\n  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.35) !important;\n  transform: translateY(-1px);\n}\n\n/* ===== Sequence Cell Styles ===== */\n\n.sequence-cell {\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  padding: 0 !important;\n}\n\n.sequence-input {\n  width: 100% !important;\n  height: 100% !important;\n  flex: 1;                     /*  key for flex fill */\n  padding: 0 24px 0 12px;     /*  leave space for arrows on right */\n  box-sizing: border-box;\n  border: none;\n  background: transparent;\n  text-align: center;         /* keep your earlier alignment */\n}\n\n\n.sequence-input:focus {\n  box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.4);\n  border-color: #4f46e5;\n}\n\n.new-seq-cell-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.new-seq-cell-wrapper .sequence-input {\n  width: 100%;\n  padding-right: 28px; /* Make space for the icon */\n}\n\n.clear-icon {\n  position: absolute;\n  right: 8px;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.clear-icon:hover {\n  color: #ef4444;\n}\n\n/* Remove padding applied by table rule */\n.banana-table-theme td > .new-seq-cell {\n  padding: 0 !important;\n}\n\n/* Ensure full stretch */\n.new-seq-cell {\n  display: flex;\n  width: 100%;\n  height: 100%;\n}\n\n/* ===== Editable Table Overrides ===== */\n\n.banana-table-theme {\n  position: relative;\n}\n\n\n\n.banana-table-shrink {\n  transform: scale(0.88) translateY(8px);\n  transform-origin: center top;\n  width: 90%;\n}\n\n\n/* ===== On Hand Cell Styles ===== */\n.on-hand-cell {\n  display: flex;\n  align-items: baseline;\n  justify-content: center !important;\n  gap: 4px;\n  background-color: #f3f4f6;\n  padding: 4px 8px;\n  border-radius: 16px;\n  width: 100%;\n  margin: 0 auto;\n  border: 1px solid #e5e7eb;\n}\n\n.on-hand-quantity {\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: #1f2937;\n}\n\n.on-hand-unit {\n  font-size: 0.9rem;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.location-display {\n  display: flex;\n  align-items: center;\n  justify-content: center !important;\n  width: 100%;\n  text-align: center;\n}\n\n.status-cell {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 6px;\n  width: 100%;\n  text-align: center;\n}\n\n.status-cell .lock-icon {\n  color: #ef4444;\n}\n\n.sequence-update-note {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  margin-bottom: 12px;\n  padding: 10px 14px;\n\n  background: linear-gradient(135deg, #eff6ff, #dbeafe);\n  border: 1px solid #93c5fd;\n  border-left: 4px solid #2563eb;\n  border-radius: 8px;\n\n  color: #1e3a8a;\n  font-size: 0.85rem;\n  font-weight: 500;\n\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.08);\n}\n\n.sequence-note-asterisk {\n  color: #2563eb;\n  font-weight: 800;\n  font-size: 1rem;\n  flex-shrink: 0;\n}\n\n.sequence-update-note svg {\n  color: #2563eb;\n  flex-shrink: 0;\n}\n\n\n\n\n.nested-item-row {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n\n  min-height: 36px;\n\n  padding: 8px 12px !important;\n\n  border-bottom: 1px solid #e5e7eb;\n  box-sizing: border-box;\n}\n\n.nested-item-row:last-child {\n  border-bottom: none;\n}\n\n.nested-onhand-row {\n  gap: 4px;\n  background: #f8fafc;\n}\n\n/* Optional tree-style bullet */\n\n.nested-item-row::before {\n  content: \"•\";\n  color: #4f46e5;\n  font-weight: bold;\n  margin-right: 8px;\n}\n\n/* ==========================================\n   Combined Item + Inventory Column\n========================================== */\n\n\n.nested-item-row {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n\n  width: 100%;\n  min-height: 36px;\n\n  padding: 8px 12px !important;\n\n  border-bottom: 1px solid #e5e7eb;\n}\n\n\n.inventory-item-id {\n  font-weight: 600;\n  color: #1f2937;\n  font-family: 'JetBrains Mono', monospace;\n}\n\n.inventory-divider {\n  flex: 1;\n  margin: 0 12px;\n  border-bottom: 1px dashed #cbd5e1;\n}\n\n.inventory-onhand {\n  font-weight: 600;\n  color: #4f46e5;\n  white-space: nowrap;\n}\n\n.empty-item {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 100%;\n}\n\n/* ==========================================\n   Inventory Cards\n========================================== */\n\n.nested-item-container {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 6px;\n  width: 100%;\n  padding: 4px !important;\n}\n\n.inventory-card {\n  display: flex !important;\n  justify-content: space-between !important;\n  align-items: center !important;\n  gap: 8px;\n\n  min-height: 36px;\n  padding: 8px 12px !important;\n\n  border-radius: 10px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.inventory-card:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 10px rgba(0,0,0,0.08);\n}\n\n.inventory-item-id {\n  font-family: 'JetBrains Mono', monospace;\n  font-weight: 700;\n  margin-right: 4px;\n}\n\n.inventory-onhand {\n  font-size: 0.85rem;\n  font-weight: 700;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
